module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-SemiBold.b7757aa.woff2";